import { oz } from '@weft/utils';
import { HubspotContactSchema } from './hubspot-contact-schema';

const hubspotOwnerIdProperty = 'hubspot_owner_id';
const hubspotRecentDealCloseDateProperty = 'recent_deal_close_date';

export const HubspotCompanySchema = oz.object({
  id: oz.string(),
  properties: oz.object({
    name: oz.string(),
    createdate: oz.string(),
    city: oz.string(),
    country: oz.string(),
    address: oz.string(),
    zip: oz.string(),
    [hubspotOwnerIdProperty]: oz.string(),
    phone: oz.string(),
    [hubspotRecentDealCloseDateProperty]: oz.string(),
    contactId: oz.string().optional(),
  }),
  contact: HubspotContactSchema.optional(),
});

export type HubspotCompany = oz.infer<typeof HubspotCompanySchema>;